import { render } from "./TablaBoletosComprados.vue?vue&type=template&id=bbf4c5fe&scoped=true"
import script from "./TablaBoletosComprados.vue?vue&type=script&lang=js"
export * from "./TablaBoletosComprados.vue?vue&type=script&lang=js"

import "./TablaBoletosComprados.vue?vue&type=style&index=0&id=bbf4c5fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf4c5fe"]])

export default __exports__